import React, { useState, useRef, useEffect } from "react";
import { url, headers } from "../../utils/const";
import { GetProgram } from "../../utils/get-programs";
import { socket } from "../../io";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import Barcode from "react-jsbarcode";
import { teams } from "../../utils/tems-list";
import { Link } from "react-router-dom";
import "./bet.css";
import Hour from "../generic/hour";
import { ToPrint } from "../../utils/print";
// let print = undefined;
let bettingShow = [];
const Bet = () => {
  let newTicket = [];
  let contentPrint = "print";
  const [betted, setBetted] = useState([]);
  const inputBetted = useRef("");
  const inputValueThisBetted = useRef("");
  const inputAmoutBetted = useRef("");
  const [show, setShow] = useState(false);
  const [program, setProgram] = useState([]);
  const [ticket, setTicket] = useState();
  const [showModalPay, setShowModalPay] = useState(false);
  const [evento, setEvento] = useState();
  const [amountWin, setAmountWin] = useState(0);
  const [tkAnular, setTkAnular] = useState("");
  const [time, setTime] = useState("");
  const [hour, setHour] = useState("");
  const [nextRun, setNextRun] = useState("");
  const [run, setRun] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [firstEnter, setFirstEnter] = useState(false);
  const [textareaValue, setTextareaValue] = useState("");
  const [numberInputValue, setNumberInputValue] = useState("");
  const [currentBet, setCurrentBet] = useState([]);
  const [error, setError] = useState("");
  const [PrintSt, setPrintSt] = useState();
  const [active, setActive] = useState(false);
  const [inTeclado, setInTeclado] = useState("");
  const [winner, setWinner] = useState("");
  const [newTicketList, setNewTicketList] = useState([]);
  const [showTicket, setShowTicket] = useState(false);
  const [showTextArea, setShowTextArea] = useState(false);
  const [listTicket, setListTickets] = useState();
  const textareaRef = useRef(null);
  const ticketNumberRef = useRef(null);
  const inputValueRef = useRef(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [ticketToPrint, setTicketToPrint] = useState(null);
  const printRef = useRef(null);
  const [printer, setPrinter] = useState(false);
  const regex = /^(0[1-9]|[12]\d|30)$/;
  const regexRuns = /^(0[1-9]|[12]\d|30)[+-]$/;
  const regexRl = /^(0[1-9]|[12]\d|30)[Rr]$/;
  const regexP = /^(0[1-9]|[12]\d|30)[Pp]$/;
  const regexK = /^(0[1-9]|[12]\d|30)[Kk][+-]$/;
  const regexS = /^(0[1-9]|[12]\d|30)[Ss][+-]$/;
  const splitSecondCapital = (str) => {
    return str.replace(/^([A-ZÁÉÍÓÚÜa-záéíóúü])[a-záéíóúü]*([A-ZÁÉÍÓÚÜ].*)$/, "$1 $2");
  };
  //Verificacion de disponibilidad de impresora:
  // useEffect(() => {
  //   fetch("http://localhost:5000/status")
  //     .then((res) => res?.json())
  //     .then((data) => {
  //       setPrinter(data.online);
  //       fetch(`${url}/print-status`, {
  //         headers: headers,
  //         method: "post",
  //         credentials:'include',
  //         body: JSON.stringify(data),
  //       })
  //         .then((res) => res.json())
  //         .then((data) => {});
  //     }).catch((error) => { console.log(error); })  ;
  // }, [printer]);
  // Obtener el valor actual del input, forma la apuesta y la agrega al ticket
  const getInputBetted = () => {};
  useEffect(() => {
    if (localStorage.getItem("level") !== "4") return (window.location.href = "/");
  }, []);
  useEffect(() => {
    (async () => {
      socket.on("games-line", async (data) => {
        if (data) {
          setActive(data.active);
          if (data?.active == true) setEvento(data.num);
                setProgram(() => GetProgram(data.games));
        }
      });
      socket.on("hour", (hr) =>
        setHour(() => {
          const actualHr = new Date().getTime() / 1000;
          const hourSec = Math.floor(hr.hour - actualHr);
          return hourSec;
        })
      );
    })();
  }, [program]);
  useEffect(() => {
    GetTicketGames();
  }, []);


  // si se presiona enter
  const handleGetBet = (event) => {
    if (event.key === "Enter") {
      if (inputBetted.current.value !== "") {
        const thisBetInput = inputBetted.current.value;
        const option = thisBetInput;
        let thisBetCode = "";
        if (thisBetInput.trim().split("").length == 2) {
          thisBetCode = thisBetInput.trim();
        } else if (thisBetInput.trim().split("").length == 3) {
          thisBetCode = thisBetInput.split("").slice(0, -1).join("").toUpperCase();
        } else if (thisBetInput.trim().split("").length == 4) {
          thisBetCode = thisBetInput.split("").slice(0, -2).join("").toUpperCase();
        } else {
          alert("Jugada No Valida");
        }
        const gameThisBet = program.find((item) => item.home.team == thisBetCode || item.away.team == thisBetCode);
        let rate;
        if (regex.test(option)) {
          if (option == gameThisBet.home.team) {
            gameThisBet.betted = gameThisBet.home.symbol + " (Juego)";
            rate = gameThisBet.home.rate;
          }
          if (option == gameThisBet.away.team) {
            gameThisBet.betted = gameThisBet.away.symbol + " (Juego)";
            rate = gameThisBet.away.rate;
          }
          gameThisBet.code = gameThisBet.idGame + "1";
        } else if (regexRl.test(option)) {
          const thisOption = option.replace(/r/i, "");
          if (thisOption == gameThisBet.home.team) {
            gameThisBet.betted = gameThisBet.home.rl.da ? gameThisBet.home.symbol + " (RL) " + "-1.5" : gameThisBet.home.symbol + " (RL) " + "+1.5";
            rate = gameThisBet.home.rl.rate;
          }
          if (thisOption == gameThisBet.away.team) {
            gameThisBet.betted = gameThisBet.away.rl.da ? gameThisBet.away.symbol + " (RL) " + "-1.5" : gameThisBet.away.symbol + " (RL) " + "+1.5";
            rate = gameThisBet.away.rl.rate;
          }

          gameThisBet.code = gameThisBet.idGame + "1";
        } else if (regexP.test(option)) {
          const thisOption = option.replace(/p/i, "");
          if (thisOption == gameThisBet.home.team) {
            gameThisBet.betted = gameThisBet.home.rl.da ? gameThisBet.home.symbol + " (P) " + "-2.5" : gameThisBet.home.symbol + " (P) " + "+2.5";
            rate = gameThisBet.home.p.rate;
          }
          if (thisOption == gameThisBet.away.team) {
            gameThisBet.betted = gameThisBet.away.rl.da ? gameThisBet.away.symbol + " (P) " + "-2.5" : gameThisBet.away.symbol + " (P) " + "+2.5";
            rate = gameThisBet.away.p.rate;
          }
          gameThisBet.code = gameThisBet.idGame + "1";
        } else if (regexRuns.test(option)) {
          gameThisBet.betted = gameThisBet.away.symbol + " (VS) " + gameThisBet.home.symbol + "  " + option.split("").at(-1) + gameThisBet.runs;
          rate = -12;
          gameThisBet.code = gameThisBet.idGame + "2";
        } else if (regexK.test(option)) {
          const thisOption = option;
          const teamPicher = thisOption.substring(0, 2);
          const thisBet = thisOption.at(-1);
          if (teamPicher == gameThisBet.away.team) {
            const picher = gameThisBet.away.picher.name;
            gameThisBet.betted = splitSecondCapital(picher.replace(/ /g, "")) + " (Ponches) " + thisBet + gameThisBet.away.k;
            rate = -12;
            gameThisBet.code = gameThisBet.idGame + "3";
          } else if (teamPicher == gameThisBet.home.team) {
            const picher = gameThisBet.home.picher.name;
            gameThisBet.betted = splitSecondCapital(picher.replace(/ /g, "")) + " (Ponches) " + thisBet + gameThisBet.home.k;
            rate = -12;
            gameThisBet.code = gameThisBet.idGame + "3";
          }
        } else if (regexS.test(option)) {
          const thisOption = option;
          const team = thisOption.substring(0, 2);
          const thisBet = thisOption.at(-1);
          if (team == gameThisBet.away.team) {
            gameThisBet.betted = gameThisBet.away.symbol + " (Solo) " + thisBet + gameThisBet.away.s;
            rate = -12;
            gameThisBet.code = gameThisBet.idGame + "1";
          } else if (team == gameThisBet.home.team) {
            gameThisBet.betted = gameThisBet.home.symbol + " (Solo) " + thisBet + gameThisBet.home.s;
            rate = -12;
            gameThisBet.code = gameThisBet.idGame + "1";
          }
        } else {
          return alert("La Jugada No es Valida");
        }

        if (!gameThisBet) return alert("La Jugada Digitada No es Valida");
        const thisBetted = {
          number: betted.length + 1,
          code: gameThisBet.code,
          option: option,
          rate,
          betted: gameThisBet.betted,
        };

        if ((!thisBetted.option.toUpperCase().includes("K") && betted.some((item) => item.code === thisBetted.code)) || (thisBetted.option.toUpperCase().includes("K") && betted.some((item) => item.betted.includes(splitSecondCapital(thisBetted.betted.split("(Ponches)")[0].trim().replace(/ /g, "")))))) {
          alert("Jugada repetida o Contradictoria");
        } else {
          setBetted((value) => (value.length > 0 ? [...value, thisBetted] : [thisBetted]));
        }

        inputBetted.current.value = "";
        inputValueThisBetted.current.focus();
      } else {
        if (betted.length >= 3 && betted.length <= 12) {
          if (inputAmoutBetted.current.value == "") inputAmoutBetted.current.value = "50";
          const monto = parseFloat(inputAmoutBetted.current.value);
          inputAmoutBetted.current.focus();
          inputAmoutBetted.current.select();
          setAmountWin(betted.reduce((acum, current) => acum * (1 + (current.rate < 0 ? (-1 * 10) / current.rate : current.rate / 10)), monto));
        } else {
          alert("La jugada debe estar comprendida entre tripleta y octava");
          inputBetted.current.focus();
        }
      }
    }
  };
  const  handleGetAmountThisBet=(event)=>{
    if (event.key === "Enter") {}
  }
  const handleGetAmountWin = (amoutThisTicket) => {
    setAmountWin(betted.reduce((acum, current) => acum * (1 + (current.rate < 0 ? (-1 * 10) / current.rate : current.rate / 10)), amoutThisTicket));
  };
  const handleGetAmountBet = async (event) => {
    if (event.key === "Enter") {
      if (isPrinting) return; // ⛔ ya hay un ticket en proceso, no permitir otro
      if (inputAmoutBetted.current.value !== "" && inputAmoutBetted.current.value > 0 && parseFloat(amountWin)<100000) {
        const amount = inputAmoutBetted.current.value;
        setIsPrinting(true); // 🚦 bloqueamos doble envío
        try {
          const res = await fetch(`${url}/ticket`, {
            method: "post",
            headers: headers,
            credentials:'include',
            body: JSON.stringify({
              betted,
              amount,
              event: evento,
              amountToWin: amountWin,
            }),
          });
          const data = await res.json();

          if (data.msg === "ok") {
            if (data.ticket) {
              const dataToPrint =data.ticket;
            dataToPrint.type ="ticket";
            dataToPrint.system ="mlb"
            dataToPrint.sys ="VLB"
              ToPrint(dataToPrint);
              setTicketToPrint(undefined);
              GetTicketGames();
            }

            setTicket(data.ticket);
            setBetted([]);
            inputAmoutBetted.current.value = "";
            inputBetted.current.focus();
            GetTicketGames(); // refrescar lista solo aquí
          }else{
            alert('Monto Superado')
          }
        } finally {
          setIsPrinting(false);
        }
      } else {
        alert("Monto no Valido o Monto a Ganar superado");
      }
    }
  };

  const handleShowModalPay = () => {
    setShowModalPay(true);
  };
  const handleCloseModalPay = () => {
    setShowModalPay(false);
  };
  //Cancelar Jugada Actual
  const CancelarThisBet = () => {
    setBetted([]);
  };
  /**Retirar una jugada */
  const Retirar = (index) => {
    betted.splice(index, 1);
  };
  /**Eliminar */
  const Eliminar = (tk) => {
    if (tk && tk !== "") setTkAnular(tk);
    if (tkAnular !== "") {
      setShow(true);
    } else {
      setInputValue("");
      setFirstEnter(false);
      setNewTicketList([]);
      //newTicket = [];
      bettingShow = [];
      setTextareaValue("");
      setCurrentBet([]);
    }
  };
  /**Obtiene los tickets de venta actual */
  const GetTicketGames = () => {
    fetch(`${url}/ticket/tickets-games`, { method: "get", headers: headers,credentials:'include' })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setListTickets(data);
      });
  };
  /**Eliminar Ticket */
  const EliminarTicket = (tk) => {
    fetch(`${url}/ticket/pay`, {
      method: "post",
      headers: headers,
      body: JSON.stringify({ ticket: tk, action: "Delete" }),
      credentials:'include'
    })
      .then((res) => res.json())
      .then((data) => {
        if (typeof data != "string" && !data.msg) {
          setWinner("");
          setWinner(() => data.amountToPay);
        } else if (typeof data == "string") {
          setWinner("");
          setWinner(() => data);
        } else if (data.msg && data.msg.includes("agado")) {
          ToPrint(data.ticket);
          setWinner(data.msg);
        }
        if (showTicket === true) {
          setTimeout(() => setShowTicket(false), 150);
          Clear();
        }
        setShow(false);
      });
  };

  /**Limpia el input del ticket */
  const Clear = () => {
    setInTeclado("");
  };
  /**Enter Para Pago */
  const EnterPay = (action) => {
    setShowTextArea(true);
    setShowTicket(false);
    fetch(`${url}/ticket/pay`, {
      method: "post",
      headers: headers,
      credentials:'include',
      body: JSON.stringify({ ticket: ticketNumberRef.current.value, action }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (typeof data === "string" && data.toUpperCase().includes("NO GANADOR")) {
        }
        if (typeof data != "string" && !data.msg) {
          setWinner("");
          setWinner(() => parseInt(data.amountToPay).toLocaleString());
        } else if (typeof data == "string") {
          setWinner("");
          setWinner(() => data);
          Clear();
          setInputValue("");
          setFirstEnter(false);
        } else if (data.msg && data.msg.includes("agado")) {
          ToPrint({ point: data.ticket.point.name, amountToPay: data.ticket.winner.amountToPay, type: "pago" });
          setPrintSt(() => data.ticket);
          setWinner(data.msg);
          Clear();
          setInputValue("");
          setFirstEnter(false);
        } else {
          if (data.hasOwnProperty("msg") && data.msg.includes("petid")) {
            setWinner(data.msg);
            ToPrint(data.ticket);
            setPrintSt(() => data.ticket);
            setInTeclado("");
            setTextareaValue("");
            setInputValue("");
            setFirstEnter(false);
          }
        }
      });
  };
  /**Imprime lineas */
  const PrintLine = () => {
    window.print();
  };
  const handleShow = () => {
    window.location.href = "/line";
  };
  const handleClose = () => {
    setShow(false);
  };
  return (
    <div className="container-fluid col-12 m-0 p-0 row justify-content-center">
      <header className="bg-dark m-0 p-0 col-12 no-print">
        <nav className="col-12 row justify-content-center">
          <div className="col-8 row">
            <Link className="col btn btn-primary form-control p-3 m-3 text-white" to="/venta">
              Cuadre Caja
            </Link>
            <div className="col btn btn-primary form-control p-3 m-3 text-white" onClick={handleShow}>
              Linea
            </div>
            <div className="col btn btn-primary form-control p-3 m-3 text-white" onClick={handleShowModalPay}>
              Pagar
            </div>
            <Link className="col btn btn-primary form-control p-3 m-3 text-white" to="/player">
              Jugadores
            </Link>
          </div>
          <div className="col-4 row justify-content-end m-0 p-0">
            <div className="col-4">{printer == false ? <button>Falla Impresora</button> : ""}</div>
            <div className="col-4 btn btn-danger form-info p-3 m-3 text-white">Cerrar</div>
          </div>
        </nav>
      </header>
      {active == true ? (
        <div>
          <div className="col-10 row m-3 p-3 border justify-content-center rounded-3">
            <div className="col-12 h-1 text-danger no-print row pt-3 mt-3">
              {active === true ? (
                <div className="col pt-3 mt-3">
                  <Hour num={evento} />
                </div>
              ) : (
                <div></div>
              )}
            </div>
            <div className=" col-12 row mt-1">
              <div className="col-6">
                <input className="form-control" type="text" ref={inputBetted} onKeyDown={handleGetBet} />
              </div>
              <div className="col-3">
                <input className="form-control" type="number" ref={inputValueThisBetted} onKeyDown={handleGetAmountThisBet} disabled />
              </div>
              <div className="col-3">
                <button type="button" className="btn btn-primary form-control" onClick={() => setShow((value) => !value)}>
                  Agregar
                </button>
              </div>
            </div>
            <div className="col-12 table-responsive mt-3">
              <table className="table table-bordewhite table-sm">
                <thead>
                  <tr>
                    <th>Número</th>
                    <th>Codigo</th>
                    <th>Apuesta</th>
                    <th>Linea</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {betted.length > 0 ? (
                    betted.map((item, index) => (
                      <tr key={index}>
                        <td>{item.number}</td>
                        <td>{item.option}</td>
                        <td>{item.betted}</td>
                        <td>{item.rate}</td>
                        <td>
                          <button type="button" className="btn btn-danger btn-sm" onClick={() => Retirar(index)}>
                            x
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr></tr>
                  )}
                </tbody>
              </table>
              <div className="col-12 row mb-3 justify-content-end mr-0 pr-0">
                <div className="col-4">
                  <label htmlFor="" className="label fs-4 text-white">
                    Monto A Ganar:
                  </label>
                </div>
                <div className="col-4">
                  <label htmlFor="" className="label fs-4 text-white">
                    {parseInt(amountWin)}
                  </label>
                </div>
                <div className="col-4 mr-0 pr-0 justify-content-end">
                  <label htmlFor="" className="label fs-4">
                    Monto Apostado
                  </label>
                </div>
                <div className="col-3 mr-0 pr-0">
                  <input type="number" className="form-control" ref={inputAmoutBetted} onKeyDown={handleGetAmountBet} onChange={()=>handleGetAmountWin(inputAmoutBetted.current.value)}/>
                </div>
              </div>
              <div className="col-12 row mb-3 mr-0 pr-0">
                <div className="col-6">
                  {" "}
                  <button type="button" className="btn btn-warning form-control" onClick={CancelarThisBet}>
                    {" "}
                    Cancelar
                  </button>
                </div>
                <div className="col-6">
                  {" "}
                  <button type="button" className="btn btn-primary form-control">
                    Imprimir
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 table-responsive mt-3 no-print">
            <table className="table table-bordewhite table-sm">
              <thead>
                <tr>
                  <th>Número</th>
                  <th>Codigo</th>
                  <th>Apuestado</th>
                  <th>Monto a Ganar</th>
                  <th>Elimnar</th>
                </tr>
              </thead>
              <tbody>
                {listTicket && listTicket.length > 0 ? (
                  listTicket.map((item, index) => (
                    <tr key={`bet-tr-${item.id}-${index}`}>
                      <td>{item.num}</td>
                      <td>{item._id}</td>
                      <td>{item.amount}</td>
                      <td>{item.pay}</td>
                      <td>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => Eliminar(item.num)}>
                          x
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr></tr>
                )}
              </tbody>
            </table>
            <div className="col-12 row mb-3 justify-content-end mr-0 pr-0"></div>
          </div>
          <div className="print" ref={printRef}>
            {ticketToPrint ? (
              <div>
                <Barcode value={ticketToPrint.num} options={{ height: 20, displayValue: false }} />
                <h6>{ticketToPrint.pv}</h6>
                <h6>Ticket No.: {ticketToPrint.num}</h6>
                <h6>Games: {`VLB-${evento}`}</h6>
                <h6>
                  Fecha: {new Date(ticketToPrint.date).toLocaleDateString("es-ES")} {new Date(ticketToPrint.date).toLocaleTimeString("es-ES")}
                </h6>
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Jugada</th>
                      <th>Linea</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ticketToPrint.betted.map((z, index) => (
                      <tr key={index}>
                        <td>{z.betted}</td>
                        <td>{z.rate > 0 ? "+" + z.rate : z.rate}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div>
                  <div>Apostado: {ticketToPrint.amount.toLocaleString("en-EN")}</div>
                  <div>Gana: {parseInt(ticketToPrint.amountToWin).toLocaleString("en-EN")}</div>
                </div>
              </div>
            ) : (
              "No Print"
            )}
          </div>
        </div>
      ) : (
        <div className="fs-1 p-3 m-3">
         Playing...

        </div>
      )}
      <Modal show={showModalPay} className="no-print">
        <ModalHeader className="bg-dark m-0 p-0 text-white text-center no-print">
          <h4>Verificar Para pago de ticket</h4>
          <button className="btn btn-close bg-white" onClick={handleCloseModalPay}></button>
          <div></div>
        </ModalHeader>
        <ModalBody className="no-print">
          <div className="col-12 row justify-content-between no-print">
            <div className="col-6 text-end fs-3">Digite el ticket:</div>
            <div className="col-6">
              <input type="text" className="form-control border border-secondary" ref={ticketNumberRef} />
            </div>
            <div>
              <strong className="m-2 p-2 fs-3">{winner}</strong>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="col-12 row justify-content-between no-print">
            <div className="col-4 no-prin">
              <button type="button" className="form-control btn btn-warning no-print" onClick={handleCloseModalPay}>
                Cancelar
              </button>
            </div>
            <div className="col-4">
              <button type="button" className="form-control btn btn-primary no-print" onTouchStart={() => EnterPay("pay")} onClick={() => EnterPay("pay")}>
                Verificar
              </button>
            </div>
          </div>
        </ModalFooter>
      </Modal>
      {/*<Modal show="false" className="modal">
        <ModalHeader>
          <div>Linea</div>
          <div className="btn btn-close no-print" onClick={handleClose}></div>
        </ModalHeader>
        <ModalBody className="print">
          <div>GALLOS SPORT</div>
          <div>games de {new Date().toLocaleDateString("es-ES")}</div>
          <div className="container-fluid">
            <div className="col-12 row justify-content-between">
              <div className="col-1 text-center bl">BL</div>
              <div className="col-1 text-center pl">PL</div>
              <div className="col-6 text-center trabas">TRABAS</div>
              <div className="col-2 text-center">LINEA</div>
              <div className="col-2 text-center time">TIEMPO</div>
            </div>
            {program && program.length > 0 ? (
              program.map((z, index) => (
                <div className="col-12 row justify-content-between" key={index * 1000}>
                  <div className="col-1 text-center bl">{z.num}</div>
                  <div className="col-1 text-center bl">{z.code}</div>
                  <div className="col-6 text-center trabas">
                    <div className="col-12 text-center">{z.away}</div>
                    <div className="col-12 text-center">{z.home}</div>
                  </div>
                  <div className="col-2 text-center bl">
                    <div>{z.away.rate}</div>
                    <div>{z.home.rate}</div>
                  </div>
                  <div className="col-2 text-center time">{z.runs}</div>
                  <hr />{" "}
                </div>
              ))
            ) : (
              <div>No Hay games Disponibles</div>
            )}
          </div>
        </ModalBody>
        <ModalFooter className="no-print">
          <div className="col-12 row">
            <div className="col justify-content-end">
              {" "}
              <button className="btn form-control">Cerrar</button>
            </div>
            <div className="col justify-content-end">
              {" "}
              <button className="btn btn-primary form-control" onClick={PrintLine}>
                Imprimir
              </button>
            </div>
          </div>
        </ModalFooter>
      </Modal>*/}
      <div className="no-print">
        <Modal show={show} onHide={!show} size="sm" className="" centered>
          <Modal.Header closeButton></Modal.Header>
          <form>
            <Modal.Body>
              <h3>Desea Anular Tickey {tkAnular}?</h3>
            </Modal.Body>
            <Modal.Footer className="col-12 row justify-content-between">
              <div className="col">
                {" "}
                <button type="button" className="btn btn-warning form-control" onClick={() => setShow(false)}>
                  Cerrar
                </button>
              </div>
              <div className="col">
                {" "}
                <button type="button" onClick={() => EliminarTicket(tkAnular)} className="btn btn-danger form-control">
                  {" "}
                  Aceptar{" "}
                </button>
              </div>
            </Modal.Footer>
          </form>
        </Modal>
        <Modal show={showTicket} onHide={!showTicket} size="" className="noPrint" centered>
          <Modal.Header>
            <button className="btn btn-close" onClick={() => setShowTicket(false)}></button>
          </Modal.Header>
          <form>
            <Modal.Body className="col-12 text-center fs-1">Ticket: {inTeclado}</Modal.Body>
            <Modal.Footer>
              <div className="col-12 row">
                <div className="col">
                  <input className="btn btn-primary form-control fs-3" type="button" onClick={() => EnterPay("pay")} onTouchStart={() => EnterPay("pay")} value={"Pagar"} />
                </div>

                <div className="col">
                  <input type="button" className="form-control btn btn-danger fs-3" onClick={Eliminar} value="Eliminar" />
                </div>
                <div className="col">
                  <button type="button" className="form-control btn btn-warning fs-3" onClick={() => EnterPay("repeat")}>
                    Repetir
                  </button>
                </div>
              </div>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default Bet;
